import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { RouteDictionary } from 'utils';

import { ymAsync } from '../../../../utils/functions/ymWrapper';
import { PrimaryButtonColor } from '../../../common/buttons/decorators/PrimaryButton/PrimaryButton';
import { CustomLink, Flex, PrimaryButton } from '../../../index';
import { AlignItems, JustifyContent } from '../../../layout/Flex/Flex';

export enum BannerBlockVariant {
  IDENTIFICATION = 'identification',
  CONTRACT = 'contract',
  DEPOSIT = 'deposit',
  VERIFIED = 'verified',
  SURVEY = 'survey',
}

interface Props {
  variant: BannerBlockVariant;
  params?: string;
}

type IBlock = Record<
  BannerBlockVariant,
  {
    textWarning: string;
    button?: {
      route: RouteDictionary;
      text: string;
    };
  }
>;

const blockVariant: IBlock = {
  [BannerBlockVariant.IDENTIFICATION]: {
    textWarning:
      'Чтобы пользоваться услугами Платформы, вам необходимо пройти верификацию инвестора',
    button: {
      route: RouteDictionary.IDENTIFICATION,
      text: 'Пройти',
    },
  },
  [BannerBlockVariant.CONTRACT]: {
    textWarning: 'Чтобы начать инвестировать, вам необходимо подписать Агентский договор',
    button: {
      route: RouteDictionary.SIGN_CONTRACT,
      text: 'Перейти к заключению',
    },
  },
  [BannerBlockVariant.DEPOSIT]: {
    textWarning:
      'Ваши данные находятся на проверке у администратора. Обычно это занимает до 1-2\n' +
      '                                    рабочих дней',
  },
  [BannerBlockVariant.VERIFIED]: {
    textWarning: 'Пополните счет, чтобы начать инвестировать в проекты',
    button: {
      route: RouteDictionary.DEPOSIT,
      text: 'Пополнить',
    },
  },
  [BannerBlockVariant.SURVEY]: {
    textWarning: 'Оцените опыт работы с Conomica, опрос займет не больше 1 минуты',
    button: {
      route: RouteDictionary.SURVEY,
      text: 'Пройти опрос',
    },
  },
};

const BannerBlock = ({ variant, params }: Props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const button = blockVariant[variant].button;
  const isSignContract = button?.route === RouteDictionary.SIGN_CONTRACT;

  const openSignContract = () => {
    ymAsync('sign-agency-offer-button');
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('sign-contract', '');
    navigate({ pathname: location.pathname, search: searchParams.toString() });
  };

  return (
    <Flex justifyContent={JustifyContent.BETWEEN} alignItems={AlignItems.CENTER}>
      <div>{blockVariant[variant].textWarning}</div>

      {button && (
        <div
          onClick={() => {
            if (!isSignContract) {
              ymAsync('sign-agency-offer-button');
            }
          }}
        >
          <PrimaryButton color={PrimaryButtonColor.GREEN}>
            {isSignContract ? (
              <button type="button" onClick={openSignContract}>
                {button.text}
              </button>
            ) : (
              <CustomLink to={button.route} params={{ uuid: params }}>
                {button.text}
              </CustomLink>
            )}
          </PrimaryButton>
        </div>
      )}
    </Flex>
  );
};

export default BannerBlock;
